import { useEffect, useState } from "react";

const LAST_USED_WALLET_KEY = "solomon:wallet:last-used:v1";

/** History is separate from ConnectorKit's permission to restore a session. */
export function useLastUsedWallet(connectedWalletId: string | null): string | null {
    const [lastUsedWalletId, setLastUsedWalletId] = useState<string | null>(() => {
        try {
            return window.localStorage.getItem(LAST_USED_WALLET_KEY);
        } catch {
            return null;
        }
    });

    useEffect(() => {
        if (!connectedWalletId) return;
        setLastUsedWalletId(connectedWalletId);
        try {
            window.localStorage.setItem(LAST_USED_WALLET_KEY, connectedWalletId);
        } catch {
            // Keep session history usable when browser storage is unavailable.
        }
    }, [connectedWalletId]);

    return lastUsedWalletId;
}
